import React, { useEffect, useState } from "react";
import useSWRMutation from "swr/mutation";
import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Separator } from "../../components/ui/separator";
// import { message } from "antd";
import { useNavigate } from "react-router-dom";
import requestErrorHandler from "../../util/requestErrorHandler";
import useAuth from "../../hooks/useAuth";
import { handleMutation } from "../../util/axios";
import { Password } from "../../components/ui/Password";
import Logo from "../..//components/Icons/Logo";


export function SignInPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const { logIn, token } = useAuth();
  const hasLoggedInOnce  = localStorage.getItem("logged-in-once")
  const { trigger, isMutating, error } = useSWRMutation(
    "fleet/login",
    handleMutation
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const data = await trigger(formData);
      // message.success("Login successful");
      logIn(data.data, data.token);  
      
      navigate(hasLoggedInOnce === "true" ? "/" : "/welcome");
      // Store token in localStorage or context
      localStorage.setItem("token", data.token);
    } catch (err: any) {
      requestErrorHandler(err);
      console.error("Login error:", err);
    }
  };

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token, navigate]);

  return (
    <div className="h-full max-w-md mx-auto flex flex-col justify-center p-4 md:p-8 space-y-8">
      <Logo size="large" />
      <h1 className="text-xl md:text-2xl font-bold !mb-4 text-center">Sign In to Your Account</h1>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="email" className="block font-medium">
              Email address
            </label>
            <Input
              id="email"
              name="email"
              type="email"
              placeholder="Enter email address"
              value={formData.email}
              onChange={handleChange}
              required
              className="bg-gray-200 border-none"
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="password" className="block font-medium">
              Password
            </label>
            <Password
              id="password"
              name="password"
              type="password"
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
              required
              className="bg-gray-200 border-none pl-2"
            />
          </div>

          {error && <p className="text-red-500 text-sm">{error.message}</p>}
        </div>

        <div className="flex justify-center">
          <Button
            disabled={isMutating}
            type="submit"
            className="text-lg w-1/2 bg-blue-600 hover:bg-blue-700 text-white py-2"
          >
            {isMutating ? "Signing in..." : "Sign in"}
          </Button>
        </div>

        <div className="flex items-center gap-4">
          <Separator className="flex-1" />
          <span className="text-gray-500 text-sm">OR</span>
          <Separator className="flex-1" />
        </div>

        <div className="text-center text-sm">
          Don't have an account?{" "}
          <Link to="/register" className="text-blue-500">
            Sign up
          </Link>
        </div>
      </form>
    </div>
  );
}
